import type { NodeSpec } from "prosemirror-model";

export const switchableListNodes: Record<"details" | "detailsSummary", NodeSpec> = {
  details: {
    group: "block",
    content: "detailsSummary? block*",
    attrs: {
      open: { default: false },
      htmlOpen: { default: false },
    },
    parseDOM: [
      {
        tag: "details",
        getAttrs(node) {
          if (typeof node === "string") {
            return null;
          }
          const hasOpenAttr = node.hasAttribute("open");

          return { open: hasOpenAttr, htmlOpen: hasOpenAttr };
        },
      },
    ],
    toDOM(node) {
      return ["details", { open: node.attrs.open }, 0];
    },
  },
  detailsSummary: {
    content: "(text | mention | groupMention | emoji | unicodeEmoji | kibelaImage)*",
    parseDOM: [{ tag: "summary" }],
    toDOM() {
      return ["summary", 0];
    },
  },
} as const;
